<mat-card appearance="outlined" class="dashboard-card">
    <mat-card-header>
        <mat-card-title>
            <span id="title">{{ readAs }}</span>
            <button mat-icon-button class="more-button" [matMenuTriggerFor]="menu" aria-label="Toggle menu">
                <mat-icon id="expand-options-icon">more_vert</mat-icon>
            </button>
            <mat-menu #menu="matMenu" xPosition="before">
                @if (card.title !== 'MRR') {
                    <span>
                        @for (option of options; track option) {
                            <button mat-menu-item (click)="toggleOption(option)">
                                {{ option.readAs }}
                            </button>
                        }
                    </span>
                }
                @if (card.title === 'MRR') {
                    <span>
                        @for (option of mrrOptions; track option) {
                            <button mat-menu-item (click)="toggleOption(option)">
                                {{ option.readAs }}
                            </button>
                        }
                    </span>
                }
            </mat-menu>
        </mat-card-title>
    </mat-card-header>
    <mat-card-content class="dashboard-card-content">
        <ng-container>
            @if (card.count || card.count == 0) {
                <p class="count">{{ card.count | number: '1.0-0' }}</p>
            } @else {
                <p class="count">?</p>
            }
        </ng-container>
        <p class="about">{{ card.about }}</p>
    </mat-card-content>
</mat-card>
